export const timelineElements = [
    {
        id: 13,
        title: "Wir sind wieder da für euch!",
        location: "",
        description: "Endlich ist es wieder soweit! Hirrlingen feiert das Doppeljubiläum und wir haben nach\n" +
            "über 2,5 Jahren unseren ersten großen Auftritt am 24.07. auf der Bühne (Fotos und\n" +
            "Videos gibt’s in der Galerie!)",
        buttonText: "",
        date: "23./24.07.2022",
        icon: "work",
    },
    {
        id: 12,
        title: "Probenwoche in Dänemark",
        location: "",
        description: "Als Zeichen der Hoffnung treten wir die um ein Jahr verschobene Reise an, um uns\n" +
            "auf das nächste Konzert vorzubereiten. Leider haben uns die Verordnungen einen\n" +
            "Strich durch die Rechnung gemacht. Schön war’s trotzdem! (Bilder in der Galerie)",
        buttonText: "",
        date: "27.08. – 03.09.2021",
        icon: "school",
    },
    {
        id: 11,
        title: "Jede Hürde ist gemeistert",
        location: "",
        description: "Zwangspause wegen Corona",
        buttonText: "",
        date: "2020/2021",
        icon: "school",
    },
    {
        id: 10,
        title: "Kooperationen festigen sich",
        location: "",
        description: "Weihnachtskonzert, wieder mit dem Projektchor St. Martinus",
        buttonText: "",
        date: "22.12.2019",
        icon: "school",
    },
    {
        id: 9,
        title: "Regelmäßigkeit",
        location: "",
        description: "Erneutes Jahreskonzert",
        buttonText: "",
        date: "26.10.2019",
        icon: "school",
    },
    {
        id: 8,
        title: "Erste Kooperationen",
        location: "",
        description: "Erstes Weihnachtskonzert in Zusammenarbeit mit dem Projektchor der St. Martinus-\n" +
            "\n" +
            "Kirche",
        buttonText: "",
        date: "23.12.2018",
        icon: "school",
    },
    {
        id: 7,
        title: "Jahreskonzert",
        location: "",
        description: "Unser erstes Jahreskonzert als offizieller „Strings and more e.V.“",
        buttonText: "",
        date: "22.07.2018",
        icon: "school",
    },
    {
        id: 6,
        title: "Wir sind ein offizieller Verein! ",
        location: "",
        description: "Eintragung als Verein – ab jetzt tragen wir den Zusatz „e.V.“",
        buttonText: "",
        date: "Juni 2018",
        icon: "school",
    },
    {
        id: 5,
        title: "Endlich Konzerte",
        location: "",
        description: "Ab jetzt gibt es jährlich ein eigenes Konzert!",
        buttonText: "",
        date: "22.07.2017",
        icon: "school",
    },
    {
        id: 4,
        title: "Organisation",
        location: "",
        description: "Erste offizielle Gründerversammlung",
        buttonText: "",
        date: "2016",
        icon: "school",
    },
    {
        id: 3,
        title: "Unser Name",
        location: "",
        description: "Erste CD-Aufnahme. Natürlich muss nun auch ein Name fürs Orchester her – ab jetzt heißen wir „Strings and more“",
        buttonText: "",
        date: "2009",
        icon: "school",
    },
    {
        id: 2,
        title: "Ausrichtung und der erste Auftritt",
        location: "",
        description: "Zum neuen Jahrtausend hin ändert sich auch die Ausrichtung des Orchesters in\n" +
            "Richtung moderne Musik, vorwiegend Rock und Pop. Auch größere Veranstaltungen\n" +
            "kommen hinzu. Ein Highlight war der Auftritt bei der Primetime Night in Böblingen.\n" +
            "Der Umkreis weitet sich auf bis zu 150 km aus, z.B. es folgen Auftritte in Karlsruhe,\n" +
            "Rottweil…",
        buttonText: "",
        date: "Ende 1990",
        icon: "school",
    },
    {
        id: 1,
        title: "Entstehung des Orchesters",
        location: "",
        description: "Margarethe Reiss gründet mit ihren Schüler/innen ein Streichorchester.\n" +
            "Ihr Sohn Andreas Reiss unterstützt zunächst und übernimmt schließlich die Leitung\n" +
            "des Orchesters.\n" +
            "Die ersten Jahre begleitet das Orchester vorwiegend Chöre und spielt in Kirchen im\n" +
            "Umkreis von rund 50 km.\n" +
            "Auch Ausfahrten in Deutschland und nach Österreich (Salzburg) werden\n" +
            "unternommen.",
        buttonText: "",
        date: "1989",
        icon: "school",
    }
]
